import { useAdvFilterStore } from '../../store';

export const selectHasAdvFilter = () => (state) => state.advFilter?.length > 0;

export const useHasAdvFilter = () => useAdvFilterStore(selectHasAdvFilter());
